<!-- eslint-disable vue/no-v-html -->
<template>
  <div>
    <div>在岗人数：200 进场人数：100 出场人数：80</div>
    <div>场内人数：200 劳务工人：100 管理人员：80</div>
    <div>出勤率：50%</div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import request from '@/utils/request'
import OnEvent from '../common/OnEvent.vue'

export default {
  extends: OnEvent,
  props: {
    propValue: {
      type: String,
      required: true,
      default: ''
    },
    request: {
      type: Object,
      default: () => {}
    },
    element: {
      type: Object,
      default: () => {}
    },
    linkage: {
      type: Object,
      default: () => {}
    },
    noEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      canEdit: false,
      ctrlKey: 17,
      isCtrlDown: false,
      cancelRequest: null
    }
  },
  computed: {
    ...mapState({
      editMode: state => state.compose.editMode,
      curComponent: state => state.compose.curComponent,
      projectItem: state => state.user.projectItem
    })
  },
  created() {
    // 注意，修改时接口属性时不会发数据，在预览时才会发
    // 如果要在修改接口属性的同时发请求，需要 watch 一下 request 的属性
    if (this.request) {
      // 第二个参数是要修改数据的父对象，第三个参数是修改数据的 key，第四个数据修改数据的类型
      this.cancelRequest = request(this.request, this.element, 'propValue', 'string')
    }
  },
  beforeDestroy() {
    // 组件销毁时取消请求
    this.request && this.cancelRequest()
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.v-text {
    width: 100%;
    height: 100%;
    display: table;
    position: relative;

    // &::before {
    //   content: '';
    //   position: absolute;
    //   top: 0;
    //   left: 3%;
    //   right: 3%;
    //   bottom: 0;
    //   background: #042068;
    //   -webkit-transform: perspective(1em) rotateX(-2deg);
    //   z-index: -1;
    //   -webkit-transform-origin: bottom;
    //   border: 1px solid #0066ff;
    // }

    div {
        display: table-cell;
        width: 100%;
        height: 100%;
        outline: none;
        word-break: break-all;
        font-weight: bold;
    }

    .can-edit {
        cursor: text;
        height: 100%;
    }
}

.preview {
    user-select: none;
    font-weight: bold;
}
</style>
